import axios from "axios";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { carrierUrls } from "../../URL/ApplicationUrls";
import Carrier from "../Carrier";
import { namedQueryKeyWithId } from "../../ReactQuery/namedQueryKeyWithId";

export const useFetchCarrierById = (carrierId: number | string | undefined) => {
  return useQuery<Carrier, Error>({
    queryKey: namedQueryKeyWithId("carriers", carrierId),
    queryFn: () => fetchCarrier(carrierId),
    onError: () => {
      toast.error(`An error occurred when retrieving the carrier with the Id ${carrierId}`);
    },
  });
};

const fetchCarrier = async (id: number | string | undefined) => {
  const { data: carrier } = await axios.get<Carrier>(carrierUrls.carrierWithId(id).apiUrl);

  return carrier;
};
